
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.945 5.49a8.597 8.597 0 014.285-2.305 8.645 8.645 0 014.86.383 8.565 8.565 0 013.864 2.947 8.453 8.453 0 011.618 4.559 4.575 4.575 0 012.64 1.844 4.505 4.505 0 01-.755 5.943A4.599 4.599 0 0119.439 20H5.72a5.747 5.747 0 01-3.686-1.333 5.656 5.656 0 01-1.95-3.375 5.625 5.625 0 01.704-3.827A5.705 5.705 0 013.814 8.99a8.487 8.487 0 012.131-3.5z","fill":"#282E3E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.945 5.49a8.597 8.597 0 014.285-2.305 8.645 8.645 0 014.86.383 8.565 8.565 0 013.864 2.947 8.453 8.453 0 011.618 4.559 4.575 4.575 0 012.64 1.844 4.505 4.505 0 01-.755 5.943A4.599 4.599 0 0119.439 20H5.72a5.747 5.747 0 01-3.686-1.333 5.656 5.656 0 01-1.95-3.375 5.625 5.625 0 01.704-3.827A5.705 5.705 0 013.814 8.99a8.487 8.487 0 012.131-3.5z","fill":"#FFA826"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 5.75c-.828 0-1.5.7-1.5 1.565v4.174c0 .864.672 1.565 1.5 1.565s1.5-.7 1.5-1.565V7.315c0-.864-.672-1.565-1.5-1.565zm0 8.87c-.828 0-1.5.7-1.5 1.565 0 .864.672 1.565 1.5 1.565s1.5-.7 1.5-1.565-.672-1.565-1.5-1.565z","fill":"#282E3E"}})])
          )
        }
      }
    